import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 20px 10px 20px;
  position: relative;
  width: 360px;
  transition: transform 0.2s;
  margin: 10px 0 0px;

  @media (max-width: 1600px) {
    max-width: 27vw;
  }

  @media (max-width: 1280px) {
    max-width: 35vw;
  }

  @media (max-width: 1024px) {
    max-width: 43vw;
  }

  @media (max-width: 820px) {
    max-width: 50vw;
    padding-left: 10px;
  }

  @media (max-width: 540px) {
    max-width: 83vw;
  }

  @media (max-width: 400px) {
    max-width: 90vw;
  }

  @media (max-width: 280px) {
    padding-left: 0px;
    padding-right: 0px;
    max-width: 85vw;
  }
`;

export const Content = styled.div`
  box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 14px 8px 14px 0;
  width: 100%;
  height: 100px;
  background: ${({ theme }) => theme.backgroundCard};
  display: flex;
  align-items: center;

  position: relative;

  > span {
    min-width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      min-height: 65px;
      width: 65px;
    }
  }

  div {
    height: 100%;

    span {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      max-width: 145px;

      h1 {
        line-height: 30px;
        font-size: 1.25rem;
        font-weight: 600;
        margin: 0;
        color: ${({ theme }) => theme.text};
      }

      h2 {
        line-height: 25px;
        margin: 0;
        font-weight: 500;
        font-size: 1.25rem;
        color: ${({ theme }) => theme.text};

        &:nth-child(2) {
          margin-bottom: 10px;
        }
      }
    }
  }

  button {
    position: absolute;

    background: transparent;

    right: 15px;
    top: 36px;

    svg {
      color: ${({ theme }) => theme.green};
      height: 25px;
      width: 25px;
    }
  }

  @media (max-width: 380px) {
    > span {
      min-width: 90px;
      img {
        min-height: 60px;
        width: 60px;
      }
    }
  }

  @media (max-width: 310px) {
    div {
      span {
        h1 {
          font-size: 1.5rem;
        }
        h2 {
          font-size: 1rem;
        }
      }
    }
  }

  @media (max-width: 280px) {
    height: 110px;
    div {
      span {
        h1 {
          font-size: 1.15rem;
        }
        h2 {
          font-size: 1rem;
        }
      }
    }
  }
`;
